import { OnInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { RequestServices } from 'src/app/services/request.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StorageService } from 'src/app/services/storage.service';
import { Configuration } from 'src/app/Constants/configuration';
import { MatDialogRef } from '@angular/material/dialog';
import { LogConsumoFunciones, LogConsumo } from 'src/app/utilities/logConsumo';
import { CocheSeguro } from 'src/app/modelos/cocheSeguro.model';
import { Prospecto } from 'src/app/modelos/prospecto.model';
import { DatosCotizacion } from 'src/app/modelos/datos-cotizacion.model';
import { StyleCocheSeguro } from 'src/app/modelos/styleCocheseguro.model';



@Component({
  selector: 'no-esta-auto',
  templateUrl: './no-esta-auto.component.html',
  styleUrls: ['./no-esta-auto.component.css']
})

export class NoEstaAutoComponent implements OnInit {
  public const: Configuration = new Configuration();
  public styleCocheSeguro: StyleCocheSeguro = new StyleCocheSeguro();
  public telefono: string = "";
  public celular: string = "";
  public loader: boolean = false;
  public logConsumoId: string = "";
  public logConsumoFun: LogConsumoFunciones = new LogConsumoFunciones(this.requestService, this.storageService, this.router);
  public cocheSeguro: CocheSeguro = new CocheSeguro();
  public logConsumoData: LogConsumo = new LogConsumo();
  public prospecto: Prospecto = new Prospecto();
  public desactivar: boolean = false;
  datosCotizacion: DatosCotizacion = {
    multicotiza: {
      f1: 61,
      f2: 29,
      f3: '',
      f4: new Date().getFullYear(),
      f5: 1,
      f7: 0
    },
    datosAuto: {
      paquete: 0,
      logoMarca: '',
      descripcion: ''
    }
  };

  constructor(
    private router: Router,
    private requestService: RequestServices,
    public dialoRef: MatDialogRef<NoEstaAutoComponent>,
    private snackBar: MatSnackBar,
    private storageService: StorageService) {
    if (this.storageService.ifExist("styleCocheSeguro")) {
      this.styleCocheSeguro = JSON.parse(this.storageService.getItem("styleCocheSeguro"));
    }
  }

  ngOnInit() {
    this.logConsumoId = this.storageService.getItem("logConsumoId");
    if (this.storageService.ifExist("cocheSeguro")) {
      this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      // if (this.cocheSeguro.telefono != "") {
      //   this.telefono = this.cocheSeguro.telefono;
      // }
      if (this.cocheSeguro.celular != "") {
        this.celular = this.cocheSeguro.celular;
      }
    }

    // if (!this.storageService.ifExist("logConsumoId")) {
    //   this.guardarRegistroInicioAyuda();
    // }

  }

  updatelogConsumo() {

    if (this.storageService.ifExist("cocheSeguro")) {
      this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
    }
    this.cocheSeguro.telefono = this.telefono;
    this.storageService.setItem("cocheSeguro", JSON.stringify(this.cocheSeguro));

    this.logConsumoFun.logConsumo();
    this.close();
  }

  obtenerAyuda() {
    let ayuda = this.logConsumoFun.ayudaInsert().subscribe(result => {
      if (result.error) {
        this.snackBar.open("Ocurrio un problema duarante el proceso", "", { duration: this.const.SNACK_BARTIME });
      } else if (result.ok || result.Exist_log) {
        ayuda.unsubscribe();
        this.updatelogConsumo();
      }
    });
  }

  close() {
    this.dialoRef.close({ ok: "OK" });
  }

  valida(): boolean {
    if (this.telefono == undefined || this.telefono == "" || this.telefono.length < 10) {
      return true;
    } else {
      return false;
    }
  }

  guardarRegistroInicioAyuda() {
    this.desactivar = true;
    let cocheSeguro: CocheSeguro = new CocheSeguro();
    if (this.storageService.ifExist("cocheSeguro")) {
        cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
        cocheSeguro.celular = this.telefono;
        this.storageService.setItem("cocheSeguro", JSON.stringify(cocheSeguro));
    }
    let paquete: string = "";
    switch (cocheSeguro.paquete) {
      case 0: // AMPLIA
        paquete = "AMPLIA";
        break;
      case 1: // LIMITADA
        paquete = "LIMITADA";
        break;
      case 2: // BÁSICA
        paquete = "BÁSICA";
        break;
    }
    this.logConsumoData.v1 = "94c3qaBTlOBbdUWPBkxEmg==";
    this.logConsumoData.v2 = (cocheSeguro?.prospecto?.correo) ? cocheSeguro.prospecto.correo : "";
    this.logConsumoData.v3 = (cocheSeguro?.prospecto?.nombre) ? cocheSeguro.prospecto.nombre : "";
    this.logConsumoData.v4 = (cocheSeguro?.prospecto?.cp) ? cocheSeguro.prospecto.cp : "";
    this.logConsumoData.v5 = (cocheSeguro?.dataVehiculo) ? cocheSeguro.dataVehiculo.multicotiza.f4 : 0;
    this.logConsumoData.v6 = (cocheSeguro?.dataVehiculo) ? cocheSeguro.dataVehiculo.multicotiza.f3 : '';
    this.logConsumoData.v7 = (cocheSeguro?.dataVehiculo) ? cocheSeguro.dataVehiculo.datosAuto.descripcion : '';
    this.logConsumoData.v8 = paquete;
    this.logConsumoData.v9 = (cocheSeguro?.origen) ? cocheSeguro.origen : 0;

    this.logConsumoFun.logConsumo(this.logConsumoData);
    let cleanTimer: any;
    let cuantos = 0;
    cleanTimer = setInterval(() => {
      if (this.storageService.ifExist("logConsumoId")) {
        cuantos = 2;
        let ayuda = this.logConsumoFun.ayudaInsert().subscribe(result => {
          if (result.error) {
            this.snackBar.open("Ocurrio un problema duarante el proceso", "", { duration: this.const.SNACK_BARTIME });
          } else if (result.ok || result.Exist_log) {
            ayuda.unsubscribe();
          }
        });
      }
      if (cuantos >= 2) {
        clearInterval(cleanTimer);
        this.close();
      } else {
        cuantos++;
      }
    }, 500);
  }

}
